module.exports = __webpack_public_path__ + "static/media/1007144.d074256e.jpg";